var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"about",on:{"click":_vm.toggleAbout}},[(!_vm.showAbout)?_c('span',[_vm._v("about")]):_c('span',[_vm._v("back to live")])]),_c('div',{staticClass:"container invert"},[_c('socials')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }